import React from 'react';
import { Provider } from 'react-redux'
import store from './reducers/index'
import ReactDOM from 'react-dom';
import './index.css';
import HomePage from './HomePage';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Provider store={store}>
    <HomePage />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
